import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ChevronDown, Minus } from "lucide-react";
import { useAuth } from "@/lib/auth";

// Liste de prise en main, alimentée par /api/me/steps.
export default function GettingStarted() {
  const { fetchSteps } = useAuth();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(() => localStorage.getItem("perform_gs_open") !== "0");

  const load = useCallback(() => { fetchSteps().then(setData).catch(() => setData(null)); }, [fetchSteps]);
  useEffect(() => { load(); }, [load]);

  const toggle = () => setOpen(o => { localStorage.setItem("perform_gs_open", o ? "0" : "1"); return !o; });

  if (!data || data.completed >= data.total) return null;

  return (
    <aside className="gs" data-testid="getting-started">
      <div className="gs-head">
        <div>
          <strong>Pour bien démarrer</strong>
          <small>{data.completed} / {data.total} étapes · <span>C'est parti !</span></small>
        </div>
        <button type="button" onClick={toggle} aria-expanded={open} aria-label={open ? "Réduire" : "Déployer"} data-testid="gs-toggle">
          {open ? <Minus size={14} /> : <ChevronDown size={14} />}
        </button>
      </div>
      <div className="gs-bar"><i style={{ width: `${(data.completed / data.total) * 100}%` }} /></div>
      {open && (
        <ul className="gs-list">
          {data.steps.map(s => (
            <li key={s.key} className={s.done ? "is-done" : ""}>
              <Link to={s.to} data-testid={`gs-step-${s.key}`}>
                <span className="gs-check">{s.done && <Check size={11} />}</span>
                {s.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
